import NotificationBadge from 'shared/components/atoms/NotificationBadge/NotificationBadge';

export default NotificationBadge;
